export const T = {
  en_GB: {
    paymentHistory: "Payment History",
    date: "Date",
    amount: "Amount",
    status: "Status",
    noPayments: "No payments yet",
    paid: "Paid",
    failed: "Failed",
    refunded: "Refunded",
  },
  nb_NO: {
    paymentHistory: "Betalingshistorikk",
    date: "Dato",
    amount: "Beløp",
    status: "Status",
    noPayments: "Ingen betalinger ennå",
    paid: "Betalt",
    failed: "Mislykket",
    refunded: "Refundert",
  },
} as const;
